import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button } from "ui";

interface AthleteLimitBannerProps {
  athleteCount: number;
  athleteLimit: number | null;
}

export function AthleteLimitBanner(props: AthleteLimitBannerProps) {
  const { t } = useTranslation();

  if (props.athleteLimit === null || props.athleteCount <= props.athleteLimit) {
    return null;
  }

  return (
    <div className="mb-4 flex items-center justify-between gap-4 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3">
      <p className="text-sm text-amber-900">
        <span className="font-medium">
          {t("athleteLimit.bannerTitle", {
            athleteCount: props.athleteCount,
            athleteLimit: props.athleteLimit,
          })}
        </span>{" "}
        {t("athleteLimit.bannerMessage")}
      </p>
      <Button asChild variant="outline" size="sm">
        <Link to="/settings/billing">{t("athleteLimit.changePlan")}</Link>
      </Button>
    </div>
  );
}
